import * as React from 'react'
const SvgUtarapaca = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="utarapaca_svg__uuid-c53516d6-0bfe-424d-9d99-836570f209e3"
    data-name="Layer 2"
    viewBox="0 0 49.73 72.16"
    {...props}>
    <defs>
      <style>
        {
          '.utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0{fill:#3d3d3d;stroke-width:0}.utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457,.utarapaca_svg__uuid-a836f016-8b85-4146-849e-a53484d31385,.utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df,.utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001{stroke-width:0}.utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001{fill:#1d1b3e}.utarapaca_svg__uuid-a836f016-8b85-4146-849e-a53484d31385{fill:#ccc}.utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457{fill:#fff}.utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df{fill:#eaeaea}'
        }
      </style>
    </defs>
    <g
      id="utarapaca_svg__uuid-e83f1fba-0b62-4f42-adc5-f21b067282aa"
      data-name="Layer 1">
      <path
        d="M49.66 0H.05v60.65l12.06 10.48 26.08-.45 11.37-10.47z"
        className="utarapaca_svg__uuid-a836f016-8b85-4146-849e-a53484d31385"
      />
      <path
        d="M49.66 0H.05v13.67h8.99V9.22h6.62v7.72h18.2V9.22h6.69v4.3h9.07z"
        className="utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df"
      />
      <path
        d="M47.76 1.97H1.87v9.4h4.91V6.76h11v8.07h14.15v-8.1h11.15v4.45h4.65z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="M24.85 61.88v-.05h8.46v2.42c7.06-.63 7.43-7.1 7.43-7.1V15.2h8.99l-.04 46.63-10.4 10.33H10.44L.04 61.83 0 15.2h8.99v41.95s.37 6.46 7.43 7.1v-2.42h8.42v.05Z"
        className="utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df"
      />
      <path
        d="M24.87 69.85H11.42L2.2 60.69v-43.3h4.78v40.38s.69 8.52 10.43 8.72c.84.05 1.26.05 1.26.05v-2.65h12.48v2.65s.42 0 1.26-.05c9.74-.2 10.43-8.72 10.43-8.72V17.39h4.78v43.3l-9.22 9.16H24.85Z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="m24.98 60.21-6.91-.02c-5.91-1.11-6.32-5.57-6.32-5.57V18.58h26.31v36.04s-.41 4.46-6.32 5.57l-6.91.02z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="M36.66 19.99h-23.4v19.42h23.43z"
        className="utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df"
      />
      <path
        d="M24.35 34.26h-6.87l3.88-9.63h7.36l3.7 9.63h-6.86l-.65.43z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="M28.45 25.02h-6.83l-3.59 8.82h13.81z"
        className="utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df"
      />
      <path
        d="M25.75 29.07h3.23s.37.09.37.67c-.04.45-.61.46-.61.46s-.26.17.24.33.84.85.84 1.23-.26 1.36-1.04 1.36h-1.99s-.98-.15-1.1-1.32c-.09-1.08.87-1.3.87-1.3s.26-.02.17-.3c-.09-.28-.99-1.13-.99-1.13"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="M28.77 33.14h-1.99s-.25-.04-.51-.22c-.24-.17-.54-.5-.6-1.11-.09-1.08.88-1.32.89-1.32 0 0 .1 0 .15-.08.03-.05.04-.11 0-.2-.09-.27-.97-1.12-.98-1.12l-.03-.03h3.27s.39.1.39.68c-.02.19-.13.33-.33.41-.14.06-.27.07-.29.07-.01.01-.06.05-.06.1s.06.12.3.2c.51.17.85.86.85 1.24 0 .35-.26 1.37-1.06 1.37m-2.99-4.05c.16.15.88.86.96 1.11.03.09.03.17-.01.23-.06.08-.17.09-.17.09s-.24.06-.47.24c-.21.17-.44.49-.4 1.04.06.6.35.92.58 1.09.26.18.5.22.5.22h1.99c.77 0 1.03-1 1.03-1.34 0-.38-.35-1.05-.82-1.21-.2-.07-.31-.14-.32-.23-.01-.08.07-.13.07-.13s.14 0 .29-.06c.19-.08.29-.21.31-.39 0-.55-.34-.65-.36-.65h-3.19Z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="M28.94 29.5h-2.23s.46.45.46.85-1.13.52-1.13 1.41.89 1.04.89 1.04h1.73s.78-.11.74-1.02c-.04-.91-1.06-.87-1.08-1.37-.02-.5.5-.48.5-.48s.26 0 .11-.43"
        className="utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df"
      />
      <path
        d="M26.43 21.72v-.46h-.15v-.18h-2.82v.18h-.15v.46c-.59-.09-.7.21-.7.35v.45c0 .58.48.48.48.48v.96h3.57V23s.48.09.48-.48v-.45c0-.14-.11-.45-.71-.35"
        className="utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457"
      />
      <path
        d="M26.76 24.07h-3.77v-.96c-.08 0-.2-.03-.3-.11-.12-.1-.19-.26-.19-.48v-.45s.01-.21.16-.34c.13-.11.31-.15.55-.13v-.45h.15v-.18h3.03v.18h.15v.45c.24-.02.42.03.55.13.15.12.16.29.16.34v.45c0 .22-.06.38-.19.48-.1.08-.21.11-.3.11zm-3.57-.2h3.36v-.99l.12.02s.15.03.25-.06c.07-.06.11-.17.11-.32v-.45s0-.11-.09-.18c-.1-.08-.27-.11-.5-.07l-.12.02v-.48h-.15v-.18h-2.62v.18h-.15v.48l-.12-.02c-.23-.04-.4-.01-.5.07-.08.07-.09.15-.09.18v.45c0 .15.04.26.11.32.1.08.25.06.25.06l.12-.02v.99Z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="m18 31.12-2.95 1.54 2 .09z"
        className="utarapaca_svg__uuid-a836f016-8b85-4146-849e-a53484d31385"
      />
      <path
        d="m17.11 32.86-2.44-.11 3.6-1.88-1.15 1.99Zm-1.68-.28 1.57.07.74-1.28z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="M18.63 36.43h-1.67l-.3 2.23z"
        className="utarapaca_svg__uuid-a836f016-8b85-4146-849e-a53484d31385"
      />
      <path
        d="m16.52 38.98.35-2.65h1.99zm.53-2.45-.24 1.81 1.6-1.81z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="M19.65 37.29h10.57v.31h.12v.74h-.14v.13H19.65v-.13h-.13v-.89h.11z"
        className="utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457"
      />
      <path
        d="M30.31 38.58H19.55v-.13h-.13v-1.09h.12l.02-.17h10.76v.32h.11v.95h-.13v.13Zm-10.55-.2h10.35v-.13h.13v-.54h-.11v-.32H19.75l-.02.17h-.1v.69h.13zM22.35 28.02s-.02-.56-.02-.86c0-.32.2-.92.94-.94.39-.01.53.17.65.31.11.13.19.23.43.24.51.03.62-.28.62-.29l.23.07s-.16.5-.87.46c-.35-.02-.49-.19-.61-.33-.11-.14-.19-.23-.46-.22-.69.02-.7.67-.7.69 0 .29.02.85.02.85h-.25ZM20.07 31.6h-.25c0-.47.13-.81.37-1.02.27-.24.59-.22.6-.22h1.46c.38 0 .66-.11.85-.33.29-.33.24-.82.24-.82l.24-.03s.07.6-.3 1.01c-.23.26-.58.4-1.03.41h-1.47s-.24-.02-.43.16c-.18.17-.28.45-.28.84M20.94 32.45c-.09.16-.17.31-.26.47-.08.14.14.26.21.12.09-.15.17-.31.26-.46.08-.14-.13-.26-.21-.12M24.74 25.68c-.09.14-.19.28-.28.43-.09.13.12.26.21.12l.28-.43c.09-.13-.12-.26-.21-.12"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="M23.58 27.36c-.55.81-1.1 1.62-1.66 2.43-.11.16.15.32.26.15.55-.81 1.1-1.62 1.66-2.43.11-.16-.15-.32-.26-.15M21.1 31.05c-.42.59-.84 1.19-1.26 1.78-.09.13.12.25.21.12.42-.59.84-1.19 1.26-1.78.09-.13-.12-.25-.21-.12"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="m29.49 25.27.56 1.25.58-.3s.3.49 1.13.35c.83-.15.9-1.1.77-1.5-.14-.4-.57-.68-1.05-.66-.48.02-1.98.85-1.98.85"
        className="utarapaca_svg__uuid-a836f016-8b85-4146-849e-a53484d31385"
      />
      <path
        d="M31.46 26.7c-.49 0-.75-.23-.86-.35l-.6.31-.64-1.43.08-.05c.06-.03 1.52-.84 2.03-.87.52-.03 1 .28 1.15.73.1.29.09.77-.12 1.14-.16.27-.41.44-.72.5-.12.02-.22.03-.32.03m-.79-.61.05.08s.28.43 1.02.3c.26-.05.45-.18.58-.4.18-.31.19-.73.11-.96-.12-.36-.52-.61-.95-.59-.35.02-1.39.55-1.85.8l.47 1.07.57-.29ZM24.85 35.64l-.71-.67h-6.88v-.21h6.96l.65.62.81-.62h6.95v.21h-6.88z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="m24.85 36.35-.71-.68h-6.95v-.2h7.03l.65.61.81-.61h6.98v.2h-6.91zM21.71 36.55h.65v.59z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="m22.37 37.17-.02-.02-.66-.61h.68zm-.63-.61.61.56v-.56z"
        className="utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001"
      />
      <path
        d="M23.7 36.55h.64v.59z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="m24.35 37.17-.68-.63h.68zm-.63-.61.61.56v-.56z"
        className="utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001"
      />
      <path
        d="M25.43 36.55h.64v.59z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="m26.08 37.17-.02-.02-.66-.61h.68zm-.63-.61.61.56v-.56z"
        className="utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001"
      />
      <path
        d="M27.35 36.55h.64v.59z"
        className="utarapaca_svg__uuid-a5c3ccb1-7827-440b-b91f-7afc6e4294a0"
      />
      <path
        d="m28 37.17-.02-.02-.66-.61H28zm-.63-.61.61.56v-.56z"
        className="utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001"
      />
      <path
        d="M36.67 52.84v1.84h-7.82s-.19-.19.09-.5c.28-.32 1-1.32 1-1.32l6.72-.02Z"
        className="utarapaca_svg__uuid-a836f016-8b85-4146-849e-a53484d31385"
      />
      <path
        d="M29.48 52.85s-1.56 1.73-1.67 1.91c-.11.19-.02.95-.02.95s.22.95-.11 1.56h-5.31s-.24-.82-1.41-1.58c0-.43-.06-.71-.06-.71l-.22-.02s-.26.28-.32.5c-.06.22-1.95-.04-1.99 1.02-.07.42.48.72.48.72v.22h-1.1s-.07-.76-.76-.76-1.08-.02-1.08-.02-.37-.08-.37-.97c.04-.65.54-.72.54-.72l2.95.02s1.97-.04 1.99-2.16h.78s-.35.48-.11 1.45c-.37.28-.56.45-.41 1 .15.56.39.76.87.84.13.26.3.82.3.82h4.98s.3-.09-.09-2.06c.35-.3.45-.48.39-1.08-.06-.59-.84-.76-.84-.76v-.19h2.58Z"
        className="utarapaca_svg__uuid-a836f016-8b85-4146-849e-a53484d31385"
      />
      <path
        d="m27.66 49.38-1.13 2.39 2.01-1.55.48 1.59 1.59-2.02.7.04.02-.38-2.11-2.01z"
        className="utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457"
      />
      <path
        d="m29.01 51.85-.49-1.6-2.05 1.59 1.17-2.47 1.57-1.96.02.02 2.11 2.01v.41l-.73-.04zm-.46-1.67.48 1.58 1.57-1.99.7.04v-.35l-2.07-1.99-1.54 1.92-1.09 2.32 1.96-1.52Z"
        className="utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001"
      />
      <path
        d="m33.68 48.08-1.15 2.5 2.03-1.62.49 1.65 1.64-1.88v-.83l-1.55-1.7z"
        className="utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457"
      />
      <path
        d="m32.47 50.65 1.2-2.58 1.47-1.9 1.57 1.72v.84l-1.68 1.91v-.03L34.54 49l-2.08 1.66Zm2.1-1.73.48 1.64 1.62-1.85v-.81l-1.53-1.67-1.44 1.86-1.12 2.42z"
        className="utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001"
      />
      <path
        d="m25.64 52.25-3.11.68s-.78.16-.6.78c.18.62.87.38.87.38l3.21-.7s.59-.06.46-.72c-.08-.59-.82-.42-.82-.42M26.68 54.98l-3.97.93s-.02.43.18.49c.19.05 4.12 0 4.12 0s0-1.01-.33-1.42"
        className="utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457"
      />
      <path
        d="M17.49 57.67h16.19s-.36.93-1.74.94c-1.38.01-14.23 0-14.23 0s-4.32-1.93-4.5-4.41v-1.36h7.53s.06 1.61-1.56 1.61h-2.83s-1.06-.03-1.06 1.28.7 1.28.7 1.28h1.12s.42.13.37.66M13.21 52.53v-7.4s2.18-.7 2.79-.76c.62-.06 1.29-.17 1.8.1s.57.92.71 1.1c.14.19.59.26.7.47.11.21.05.35.03.5-.02.15-.29.21-.26.65.03.44.22.26.67.31s.57 1.06.37 1.32c-.19.26-.28.37-.29.63 0 .26 1.02 1.21 1.02 1.21v1.87z"
        className="utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df"
      />
      <path
        d="M21.08 52.51h1.65s.83 0 .83-.21v-.35s-1.42.18-2.03-1.18c-.12-.32-.19-.8-.19-.8s-.16-1.48 1.23-1.91l-.03-.41s-.92.18-1.02-1.13c-.1-1.32.11-1.59.78-1.69.67-.1 1.14.55 1.26 1.1.12.56.2 1.51-.38 1.65 0 .14.05.32.05.32s1.55-.17 2.05 1.23c.5 1.39-.36 2.46-1.06 2.68-.02.12-.02.29-.02.29h.81l.55-.32 3.66-4.53 2.81 2.79 3.08-4.03 1.58 1.62v-6.56H13.21v3.73s1.83-.9 3.07-.92v-1.95s.45-.1.66-.03.89.36.91.48c.02.12 0 .96 0 .96h-.43s-.33-.38-.79-.3v.8s.94-.04 1.38.1c.44.14.68 1.07.94 1.23.26.16.78.54.8.83.02.29-.29.72-.16.88.13.17.8.1.85.66.23 1.38-.18 1.48-.13 1.82.05.34.71.44.76.94.05.5.02 2.22.02 2.22"
        className="utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457"
      />
      <path
        d="M22.74 52.54h-1.68v-.03c0-.02.03-1.72-.02-2.22-.02-.27-.23-.41-.43-.55-.16-.11-.31-.22-.33-.39-.02-.12.02-.21.06-.32.09-.23.22-.57.07-1.5-.04-.36-.34-.45-.58-.52-.12-.03-.22-.07-.27-.13-.08-.1-.01-.28.05-.47.05-.15.11-.3.1-.42-.02-.27-.52-.65-.79-.81-.11-.07-.21-.26-.33-.48-.16-.31-.35-.66-.6-.74-.43-.14-1.36-.1-1.37-.1h-.02v-.84h.02c.43-.08.75.24.8.29h.4c0-.13.02-.83 0-.93-.02-.1-.65-.38-.9-.47-.18-.06-.55 0-.63.02v1.95h-.02c-1.22.02-3.04.91-3.06.92h-.03v-3.77H36.7v6.63l-1.6-1.64-3.08 4.03-.02-.02-2.79-2.77-3.65 4.52-.55.34h-.83v-.03s0-.17.02-.29.01-.02.01-.02c.38-.12.76-.46.98-.9.19-.37.35-.97.07-1.74-.49-1.36-2.02-1.22-2.03-1.21h-.02v-.02s-.05-.19-.05-.33v-.02h.02c.63-.15.44-1.29.37-1.63-.19-.85-.84-1.15-1.24-1.09-.75.11-.85.52-.76 1.67.04.46.18.79.42.97.27.21.58.15.58.15h.02l.03.44h-.01c-1.35.42-1.21 1.87-1.21 1.89 0 0 .07.47.19.79.59 1.32 1.99 1.17 2 1.17h.02v.37c0 .22-.76.24-.85.24m-1.63-.05h1.63c.31 0 .81-.06.81-.19v-.33c-.19.02-1.46.07-2.02-1.19-.12-.32-.2-.8-.2-.8 0-.02-.14-1.49 1.22-1.92l-.03-.37c-.08.01-.35.03-.59-.16-.25-.19-.39-.52-.43-1-.1-1.33.12-1.61.8-1.71.66-.1 1.15.5 1.29 1.12.08.35.27 1.5-.38 1.67 0 .11.03.24.04.29.18-.01 1.58-.07 2.06 1.24.28.78.12 1.4-.07 1.78-.22.45-.6.8-.99.92-.01.09-.01.21-.02.25h.78l.54-.32 3.67-4.55v.02L32.03 50l3.08-4.03 1.56 1.6v-6.49H13.23v3.68c.24-.11 1.88-.88 3.02-.91V41.9h.02s.45-.11.67-.03c.11.04.9.35.92.5.02.12 0 .93 0 .96v.02h-.46s-.32-.37-.75-.3v.76c.14 0 .96-.03 1.36.1.27.08.46.44.62.76.11.21.22.41.32.47.29.18.79.55.81.84 0 .13-.05.29-.1.44-.06.18-.12.35-.06.43.04.05.14.08.25.11.24.07.57.17.61.56.16.94.02 1.29-.07 1.52-.04.11-.07.19-.06.3.02.15.16.25.32.36.2.14.42.3.44.58.04.47.02 2.01.02 2.2"
        className="utarapaca_svg__uuid-feafc9b2-d613-4081-9ddc-c3e831b72001"
      />
      <path
        d="M21.94 50.32c1.92-.07 3.03-.7 3.03-.7s.29 1.67-.99 1.88c0 0-1.92.4-2.03-1.18"
        className="utarapaca_svg__uuid-ba8c8970-5c37-4469-b144-aa09c06b54df"
      />
      <path
        d="M22.77 46.88s.08-1.57-.6-1.55c-.68.02-.37 1.3-.3 1.52.07.22.26.65.59.56s.32-.53.32-.53"
        className="utarapaca_svg__uuid-30db313d-6cd3-4b70-b5e1-6b7d98ff1457"
      />
    </g>
  </svg>
)
export default SvgUtarapaca
